import { apiClient } from "@/api/api-client.ts";

const documentService = {
	getToken: async (payload: {
		file_type: "pdf" | "doc" | "docx";
		title: string;
		url?: string;
		mode: "view" | "edit";
	}) => {
		const response = await apiClient.post<{
			data: {
				key: string;
				token: string;
				options: string;
			};
		}>("/document/config", payload);

		return response.data.data;
	},
};

export default documentService;
